/* global SwiftypeAppSearch, sonicAppSearchApiKey, sonicAppSearchEndpoint, sonicAppSearchEngineName */

const appSearchSuggestion = function() {
	if ('undefined' !== typeof SwiftypeAppSearch) {
		let client = SwiftypeAppSearch.createClient({
			apiKey: sonicAppSearchApiKey,
			endpointBase: sonicAppSearchEndpoint,
			engineName: sonicAppSearchEngineName
		});

		function searchListRender(ul,item){
			let redirect = item.value.replace(/ /g, "+"),
				highlightedLabel = String(item.label).replace(
					new RegExp(this.term, "gi"),
					"<span style='color: #115ea7; font-weight: 600;'>$&</span>"
				);

			return $("<li>")
				.append('<a style="color: #034777; font-weight: 400;" class="d-block w-100 text-decoration-none" href="/search?keyword=' + redirect + '">' + highlightedLabel + "</a>")
				.appendTo(ul);
		}

		$('.searchInput').autocomplete({
			source: function(req, res) {
				let options = {
					size: 10,
					types: {
						documents: {
							fields: [
								 'group_name',
								 'main_category_name',
								 'manufacturer_name',
								 'manufacturer_sku',
								 'sku',
								 'upc'
							]
						}
					}
				};

				client
					.querySuggestion(req.term.replace(/-/g, '_'), options)
					.then(response => {
						if (typeof response.results !== "undefined") {
							res($.map(response.results.documents, function (item) {
								return {
									"value": item.suggestion.replace(/_/g, '-'),
									"label": item.suggestion.replace(/_/g, '-')
								};
							}));
						}
					})
					.catch(function(error) {
						// Fail quietly.
						console.log('Request failed', error);
					});
			}
		});

		if ($('#searchField').length > 0) {
			$('#searchField').data( "ui-autocomplete" )._renderItem = searchListRender;
		}

		if ($('#searchFieldMobile').length > 0) {
			$('#searchFieldMobile').data( "ui-autocomplete" )._renderItem = searchListRender;
		}
	}
};

export default appSearchSuggestion;
